import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useNavigate, useParams} from "react-router-dom";
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import MemberSidebar from "../inc/MemberSidebar";
import {confirmAlert} from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';

export default function ProposalCreate(prop) {
    let navigate = useNavigate();
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let scholarshipId = decode.scholarshipId;

    let member = prop.member;
    let [detail, setDetail] = React.useState(null);

    //Applicant
    let refPrefix = React.useRef();
    let refFirstname = React.useRef();
    let refLastname = React.useRef();
    let refPrefix_en = React.useRef();
    let refFirstname_en = React.useRef();
    let refLastname_en = React.useRef();
    let refPosition = React.useRef();
    let refDepartment = React.useRef();
    let refContact = React.useRef();
    let refEducation = React.useRef();
    let refWorkHistory = React.useRef();
    let refExpertise = React.useRef();
    let refEmail = React.useRef();
    let refPhone = React.useRef();

    //Proposal
    let refTitle = React.useRef();
    let refTitle_en = React.useRef();
    let [projectTypeId, setProjectTypeId] = React.useState(Utils.PROJECT_TYPE_MAIN);
    let refProjectsub = React.useRef();
    let [researchTypeId, setResearchTypeId] = React.useState(Utils.PROJECT_RESEARCH_TYPE_NEW);
    let refBudgetYear = React.useRef();
    let refBudgetPrice = React.useRef();
    let refBudgetStart = React.useRef();
    let refSummary = React.useRef();
    let [requestOther, setRequestOther] = React.useState(Utils.REQUEST_OTHER_NO);
    let refPropOtherAgency = React.useRef();
    let refPropOtherTitle = React.useRef();
    let refPropOtherDiff = React.useRef();
    let refKeywords = React.useRef();
    let refKeywords_en = React.useRef();
    let [iscedBroad, setIscedBroad] = React.useState(null);
    let [iscedNarrow, setIscedNarrow] = React.useState(null);
    let [iscedDetailed, setIscedDetailed] = React.useState(null);
    let [oecdMain, setOecdMain] = React.useState(null);
    let [oecdSub, setOecdSub] = React.useState(null);
    let [oecdRelation, setOecdRelation] = React.useState(null);

    let [iscedBroadList, setIscedBroadList] = React.useState(null);
    let [iscedNarrowList, setIscedNarrowList] = React.useState(null);
    let [iscedDetailedList, setIscedDetailedList] = React.useState(null);
    let [oecdMainList, setOecdMainList] = React.useState(null);
    let [oecdSubList, setOecdSubList] = React.useState(null);
    let [oecdRelationList, setOecdRelationList] = React.useState(null);

    let [step, setStep] = React.useState('step1');

    React.useEffect(() => {
        window.scrollTo(0, 0);

        (async function() {
            try {
                const resDetail = await getDetail();
                if(prop !== null && prop.lang === 'en') {
                    resDetail.title = resDetail.title_en;
                }
                setDetail(resDetail);

                if(member) {
                    const resProfile = await Utils.getProfile(member);
                    refPrefix.current.value = resProfile.prefix.title;
                    refFirstname.current.value = resProfile.firstname;
                    refLastname.current.value = resProfile.lastname;
                    refEmail.current.value = resProfile.email;
                    refPhone.current.value = resProfile.phone;
                }

                const resIscedBroad = await Utils.getIscedBroad();
                setIscedBroadList(resIscedBroad);
                const resOecdMain = await Utils.getOecdMain();
                setOecdMainList(resOecdMain);

                document.title = 'ทุนวิจัย Scholarship | NCSA - ' + resDetail.title;
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getDetail() {
        const response = await fetch(Config.apiUrl +'/scholarship/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: scholarshipId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onCancel = () => {
        navigate((prop.lang === 'en' ? '/en':'') + '/scholarship/detail/' + detail?.slug);
    };

    const onNextToStep2 = async () => {
        let prefix = refPrefix.current.value;
        let firstname = refFirstname.current.value;
        let lastname = refLastname.current.value;
        let prefix_en = refPrefix_en.current.value;
        let firstname_en = refFirstname_en.current.value;
        let lastname_en = refLastname_en.current.value;
        let position = refPosition.current.value;
        let department = refDepartment.current.value;
        let contact = refContact.current.value;
        let education = refEducation.current.value;
        let workHistory = refWorkHistory.current.value;
        let expertise = refExpertise.current.value;
        let email = refEmail.current.value;
        let phone = refPhone.current.value;

        if(prefix === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Prefix (Thai)':'กรุณาระบุ คำนำหน้านาม (ภาษาไทย)');
            refPrefix.current.focus();
        }
        else if(firstname === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Firstname (Thai)':'กรุณาระบุ ชื่อจริง (ภาษาไทย)');
            refFirstname.current.focus();
        }
        else if(lastname === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Lastname (Thai)':'กรุณาระบุ นามสกุล (ภาษาไทย)');
            refLastname.current.focus();
        }
        else if(prefix_en === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Prefix (English)':'กรุณาระบุ คำนำหน้านาม (English)');
            refPrefix_en.current.focus();
        }
        else if(firstname_en === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Firstname (English)':'กรุณาระบุ ชื่อจริง (English)');
            refFirstname_en.current.focus();
        }
        else if(lastname_en === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Lastname (English)':'กรุณาระบุ นามสกุล (English)');
            refLastname_en.current.focus();
        }
        else if(position === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Academic Position':'กรุณาระบุ ตำแหน่งทางวิชาการ');
            refPosition.current.focus();
        }
        else if(department === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Department':'กรุณาระบุ หน่วยงานที่สังกัด');
            refDepartment.current.focus();
        }
        else if(contact === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Contact':'กรุณาระบุ ข้อมูลติดต่อ/ที่อยู่');
            refContact.current.focus();
        }
        else if(email === '' || !Utils.validateEmail.test(email)) {
            toast.error(prop.lang === 'en' ? 'Please specify a valid email':'กรุณาระบุ รูปแบบอีเมลให้ถูกต้อง');
            refEmail.current.focus();
        }
        else if(!phone || isNaN(phone) || phone.length !== 10) {
            toast.error(prop.lang === 'en' ? 'Please specify 10-digit Phone number.':'กรุณาระบุ ระบุเบอร์โทรศัพท์ ตัวเลข 10 หลัก');
            refPhone.current.focus();
        }
        else if(education === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Education':'กรุณาระบุ ประวัติการศึกษา');
            refEducation.current.focus();
        }
        else if(workHistory === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Work History':'กรุณาระบุ ประวัติการทำงาน');
            refWorkHistory.current.focus();
        }
        else if(expertise === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Expertise':'กรุณาระบุ ความเชี่ยวชาญ');
            refExpertise.current.focus();
        }
        else {
            setStep('step2');
            window.scrollTo(0, 0);
        }
    };

    const onSubmit = () => {
        //Applicant
        let prefix = refPrefix.current.value;
        let firstname = refFirstname.current.value;
        let lastname = refLastname.current.value;
        let prefix_en = refPrefix_en.current.value;
        let firstname_en = refFirstname_en.current.value;
        let lastname_en = refLastname_en.current.value;
        let position = refPosition.current.value;
        let department = refDepartment.current.value;
        let contact = refContact.current.value;
        let education = refEducation.current.value;
        let workHistory = refWorkHistory.current.value;
        let expertise = refExpertise.current.value;
        let email = refEmail.current.value;
        let phone = refPhone.current.value;

        //Proposal
        let code = Utils.random5Number;
        let title = refTitle.current.value;
        let title_en = refTitle_en.current.value;
        let projectSub = refProjectsub.current.value;
        let budgetYear = refBudgetYear.current.value;
        let budgetPrice = refBudgetPrice.current.value;
        let budgetStart = refBudgetStart.current.value;
        let summary = refSummary.current.value;
        let propOtherAgency = refPropOtherAgency.current.value;
        let propOtherTitle = refPropOtherTitle.current.value;
        let propOtherDiff = refPropOtherDiff.current.value;
        let keywords = refKeywords.current.value;
        let keywords_en = refKeywords_en.current.value;

        if(title === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Project name/research plan (Thai)':'กรุณาระบุ ชื่อโครงการ/แผนงานวิจัย (ภาษาไทย)');
            refTitle.current.focus();
        }
        else if(title_en === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Project name/research plan (English)':'กรุณาระบุ ชื่อโครงการ/แผนงานวิจัย (English)');
            refTitle_en.current.focus();
        }
        else if(projectTypeId === Utils.PROJECT_TYPE_SET && projectSub === '') {
            toast.error(prop.lang === 'en' ? 'Project Sub Name':'ชื่อโครงการวิจัยย่อย');
            refProjectsub.current.focus();
        }
        else if(budgetYear === '') {
            toast.error(prop.lang === 'en' ? 'That will start operations in the proposed year':'ที่เริ่มดำเนินการในปีที่เสนอขอ ดำเนินงาน');
            refBudgetYear.current.focus();
        }
        else if(budgetPrice === '') {
            toast.error(prop.lang === 'en' ? 'Total budget including projects':'งบประมาณรวมทั้งโครงการ');
            refBudgetPrice.current.focus();
        }
        else if(summary === '') {
            toast.error(prop.lang === 'en' ? 'Summary':'สรุปผลการดำเนินงานที่ผ่านมา');
            refSummary.current.focus();
        }
        else if(Utils.PROJECT_RESEARCH_TYPE_CONTINUE === researchTypeId && budgetStart === '') {
            toast.error(prop.lang === 'en' ? 'Start receiving the annual budget':'เริ่มรับงบประมาณปี');
            refBudgetStart.current.focus();
        }
        else if(Utils.REQUEST_OTHER_YES === requestOther && propOtherAgency === '') {
            toast.error(prop.lang === 'en' ? 'Agency/Institution':'ระบุหน่วยงาน/สถาบันที่ยื่น');
            propOtherAgency.current.focus();
        }
        else if(Utils.REQUEST_OTHER_YES === requestOther && propOtherTitle === '') {
            toast.error(prop.lang === 'en' ? 'Project Name':' ชื่อโครงการ');
            propOtherTitle.current.focus();
        }
        else if(Utils.REQUEST_OTHER_YES === requestOther && propOtherDiff === '') {
            toast.error(prop.lang === 'en' ? 'Differences from this project':' ระบุความแตกต่างจากโครงการนี้');
            propOtherDiff.current.focus();
        }
        else if(keywords === '') {
            toast.error(prop.lang === 'en' ? 'Please input keyword (Thai)':'กรุณาระบุ คำสำคัญ ภาษาไทย');
            refKeywords.current.focus();
        }
        else if(keywords_en === '') {
            toast.error(prop.lang === 'en' ? 'Please input keyword (English)':'กรุณาระบุ คำสำคัญ ภาษาอังกฤษ');
            refKeywords_en.current.focus();
        }
        else if(!iscedBroad) {
            toast.error(prop.lang === 'en' ? 'ISCED Broad field ':'ISCED Broad field ');
        }
        else if(!iscedNarrow) {
            toast.error(prop.lang === 'en' ? 'ISCED Narrow field ':'ISCED Narrow field ');
        }
        else if(!iscedDetailed) {
            toast.error(prop.lang === 'en' ? 'ISCED Detailed field ':'ISCED Detailed field ');
        }
        else if(!oecdMain) {
            toast.error(prop.lang === 'en' ? 'Main OECD':'สาขาการวิจัยหลัก OECD');
        }
        else if(!oecdSub) {
            toast.error(prop.lang === 'en' ? 'Sub OECD':'สาขาการวิจัยย่อย OECD');
        }
        else if(!oecdRelation) {
            toast.error(prop.lang === 'en' ? 'Relation':'สาขาที่เกี่ยวข้อง');
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            let param = {
                                scholarshipId: scholarshipId,
                                code: code,
                                memberId: member.id,
                                status: Utils.PROPOSAL_STATUS_DRAFT,
                                title: title,
                                title_en: title_en,
                                projectTypeId: projectTypeId,
                                projectSub: projectTypeId === Utils.PROJECT_TYPE_SET ? projectSub : null,
                                researchTypeId: researchTypeId,
                                budgetYear: budgetYear,
                                budgetPrice: budgetPrice,
                                budgetStart: researchTypeId === Utils.PROJECT_RESEARCH_TYPE_CONTINUE ? budgetStart : null,
                                summary: summary,
                                requestOther: requestOther,
                                propOtherAgency: requestOther === Utils.REQUEST_OTHER_YES ? propOtherAgency : null,
                                propOtherTitle: requestOther === Utils.REQUEST_OTHER_YES ? propOtherTitle : null,
                                propOtherDiff: requestOther === Utils.REQUEST_OTHER_YES ? propOtherDiff : null,
                                keywords: keywords_en,
                                keywords_en: keywords,
                                iscedBroad: iscedBroad,
                                iscedNarrow: iscedNarrow,
                                iscedDetailed: iscedDetailed,
                                oecdMain: oecdMain,
                                oecdSub: oecdSub,
                                oecdRelation: oecdRelation,
                                createdBy: -1,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedBy: -1,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            const result = await createProposal(param);

                            if (result) {
                                //create Applicant
                                let paramA = {
                                    proposalId: result.id,
                                    prefix: prefix,
                                    firstname: firstname,
                                    lastname: lastname,
                                    prefix_en: prefix_en,
                                    firstname_en: firstname_en,
                                    lastname_en: lastname_en,
                                    position: position,
                                    department: department,
                                    contact: contact,
                                    education: education,
                                    workHistory: workHistory,
                                    expertise: expertise,
                                    email: email,
                                    phone: phone,
                                    createdBy: -1,
                                    createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                                };
                                await createApplicant(paramA);

                                if (result.status === 'success') {
                                    toast.success(prop.lang === 'en' ? 'The applicant\'s information has been recorded successfully.' : 'บันทึกส่วนข้อมูลผู้ขอรับทุน เรียบร้อย');
                                    setTimeout(function () {
                                        navigate((prop.lang === 'en' ? '/en/' : '') + '/proposal');
                                    }, 1500);
                                } else {
                                    toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator' : 'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                                }
                            } else {
                                toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.' : 'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {
                        }
                    }
                ]
            });
        }
    };

    async function createProposal(param) {
        const response = await fetch(Config.apiUrl +'/proposal/createProposal', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function createApplicant(param) {
        const response = await fetch(Config.apiUrl +'/applicant/createApplicant', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onPrev = () => {
        setStep('step1');
        window.scrollTo(0, 0);
    };

    const onChangeIscedBroad = async (x) => {
        setIscedBroad(null);
        setIscedNarrow(null);
        setIscedNarrowList(null);
        setIscedDetailed(null);
        setIscedDetailedList(null);

        let boardId = x.target.value;
        if(boardId) {
            setIscedBroad(boardId);
            const resIscedNarrow = await Utils.getIscedNarrow(boardId);
            setIscedNarrowList(resIscedNarrow);
        }
    };
    const onChangeIscedNarrow = async (x) => {
        setIscedNarrow(null);
        setIscedDetailed(null);
        setIscedDetailedList(null);

        let narrowId = x.target.value;
        if(narrowId) {
            setIscedNarrow(narrowId);
            const resIscedDetailed = await Utils.getIscedDetailed(narrowId);
            setIscedDetailedList(resIscedDetailed);
        }
    };
    const onChangeIscedDetail = async (x) => {
        setIscedDetailed(null);
        let detailedId = x.target.value;
        if(detailedId) {
            setIscedDetailed(detailedId);
        }
    };

    const onChangeOecdMain = async (x) => {
        setOecdMain(null);
        setOecdSub(null);
        setOecdSubList(null);
        setOecdRelation(null);
        setOecdRelationList(null);

        let oecdMainId = x.target.value;
        if(oecdMainId) {
            setOecdMain(oecdMainId);
            const resOecdSub = await Utils.getOecdSub(oecdMainId);
            setOecdSubList(resOecdSub);
        }
    };
    const onChangeOecdSub = async (x) => {
        setOecdSub(null);
        setOecdRelation(null);
        setOecdRelationList(null);

        let oecdSubId = x.target.value;
        if(oecdSubId) {
            setOecdSub(oecdSubId);
            const resOecdRelation = await Utils.getOecdRelation(oecdSubId);
            setOecdRelationList(resOecdRelation);
        }
    };
    const onChangeOecdRelation = async (x) => {
        setOecdRelation(null);
        let oecdRelationId = x.target.value;
        if(oecdRelationId) {
            setOecdRelation(oecdRelationId);
        }
    };

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="proposal" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">
                            <div className="card-body p-0 px-xxl-3">
                                <h2 className="h3 text-center">{prop.lang === 'en' ? 'Full Proposal':'ยื่นแบบฟอร์มข้อเสนอโครงการฉบับสมบูรณ์ (Full Proposal)'}</h2>
                                <div className="text-center">{prop.lang === 'en' ? 'Strategic Research Project (Strategic Fund; SF): Research Project Type':'โครงการวิจัยเชิงกลยุทธ์ (Strategic Fund; SF) : ประเภทโครงการวิจัย'}</div>
                                <h3 className="mt-2 text-center">{prop.lang === 'en' ? 'Research Fund Name ':'ชื่อทุนวิจัย '} : {prop.lang === 'en' ? detail?.title_en : detail?.title}</h3>
                                <ul className="nav-steps">
                                    <li className={step === 'step1' ? "active":''}>
                                        <a href="#">
                                            <h3 className="number">1</h3>
                                            <p>{prop.lang === 'en' ? 'Scholarship Applicants':'ผู้ขอรับทุน'}</p>
                                        </a>
                                    </li>
                                    <li className={step === 'step2' ? "active":''}>
                                        <a href="#">
                                            <h3 className="number">2</h3>
                                            <p>{prop.lang === 'en' ? 'Part 1. General Information':'ส่วนที่ 1 ข้อมูลทั่วไป'}</p>
                                        </a>
                                    </li>
                                    <li className={step === 'step3' ? "active":''}>
                                        <a href="#">
                                            <h3 className="number">3</h3>
                                            <p>{prop.lang === 'en' ? 'Save':'บันทึกข้อมูล'}</p>
                                        </a>
                                    </li>
                                </ul>

                                {/* Step 1 */}
                                <div className={step === 'step1' ? '':'d-none'}>
                                    <h3 className="title-bar mb-4">{prop.lang === 'en' ? 'Scholarship Applicants':'ข้อมูลผู้ขอรับทุน'}</h3>
                                    <div className="row g-3 mt-4">
                                        <div className="col-xl-4 col-md-6">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Prefix (Thai)':'คำนำหน้า (ภาษาไทย)'} <span className="star">*</span></h6>
                                                <input type="text" className="form-control" ref={refPrefix} maxLength={250} />
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-md-6">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'First Name (Thai)':'ชื่อจริง (ภาษาไทย)'} <span className="star">*</span></h6>
                                                <input type="text" className="form-control" ref={refFirstname} maxLength={250} />
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-md-6">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Last Name (Thai)':'นามสกุล (ภาษาไทย)'} <span className="star">*</span></h6>
                                                <input type="text" className="form-control" ref={refLastname} maxLength={250} />
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-md-6">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Prefix (English)':'คำนำหน้า (English)'} <span className="star">*</span></h6>
                                                <input type="text" className="form-control" ref={refPrefix_en} maxLength={250} />
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-md-6">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'First Name (English)':'ชื่อจริง (English)'} <span className="star">*</span></h6>
                                                <input type="text" className="form-control" ref={refFirstname_en} maxLength={250} />
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-md-6">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Last Name (English)':'นามสกุล (English)'} <span className="star">*</span></h6>
                                                <input type="text" className="form-control" ref={refLastname_en} maxLength={250} />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Academic Position':'ตำแหน่งทางวิชาการ'} <span className="star">*</span></h6>
                                                <input type="text" className="form-control" ref={refPosition} maxLength={250} />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Department':'หน่วยงานที่สังกัด'} <span className="star">*</span></h6>
                                                <input type="text" className="form-control" ref={refDepartment} maxLength={250} />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Contact':'ข้อมูลติดต่อ/ที่อยู่'} <span className="star">*</span></h6>
                                                <textarea className="form-control" ref={refContact} maxLength={250}></textarea>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Phone':'เบอร์โทร'} <span className="star">*</span></h6>
                                                <input type="text" className="form-control" ref={refPhone} maxLength={10} />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Email':'อีเมล'} <span className="star">*</span></h6>
                                                <input type="text" className="form-control" ref={refEmail} maxLength={250} />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Education':'ประวัติการศึกษา'} <span className="star">*</span></h6>
                                                <textarea className="form-control" ref={refEducation} maxLength={1000}></textarea>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Work History':'ประวัติการทำงาน'} <span className="star">*</span></h6>
                                                <textarea className="form-control" ref={refWorkHistory} maxLength={1000}></textarea>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Expertise':'ความเชี่ยวชาญ'} <span className="star">*</span></h6>
                                                <textarea className="form-control" ref={refExpertise} maxLength={1000}></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="py-3"><hr /></div>
                                    <div className="buttons gap-15 py-0 mb-4">
                                        <button className="btn btn-gray w-130" type="button" onClick={onCancel}>{prop.lang === 'en' ? 'Cancel':'ยกเลิก'}</button>
                                        <button className="btn btn-secondary w-130" type="button" onClick={onNextToStep2}>{prop.lang === 'en' ? 'Next':'ถัดไป'}</button>
                                    </div>

                                    <p className="text-center text-danger">{prop.lang === 'en' ? 'If the form does not have the options you want, please contact the staff via the following channels ':'หากแบบฟอร์ม ไม่มีตัวเลือกที่คุณต้องการ กรุณาติดต่อเจ้าหน้าที่ผ่านช่องทาง'}  cybreplus@ncsa.or.th</p>
                                </div>

                                {/* Step 2 */}
                                <div className={step === 'step2' ? '':'d-none'}>
                                    <h3 className="title-bar mb-4">{prop.lang === 'en' ? 'Part 1. General Information':'ส่วนที่ 1 ข้อมูลทั่วไป'}</h3>
                                    <h4 className="title-line-left mt-0 mb-3">1. {prop.lang === 'en' ? 'Project name/research plan':'ชื่อโครงการ/แผนงานวิจัย'}</h4>
                                    <div className="row g-4">
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Thai':'ภาษาไทย'} <span className="star">*</span></h6>
                                                <input type="text" className="form-control" ref={refTitle} maxLength={250} />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'English':'ภาษาอังกฤษ'} <span className="star">*</span></h6>
                                                <input type="text" className="form-control" ref={refTitle_en} maxLength={250} />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Project Type':'ประเภทโครงการ'} <span className="star">*</span></h6>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-check lg">
                                                            <input className="form-check-input" type="radio" value="" id="projectTypeId1" name="projectTypeId1" onChange={e => setProjectTypeId(Utils.PROJECT_TYPE_MAIN)} checked={Utils.PROJECT_TYPE_MAIN === projectTypeId} />
                                                            <label className="form-check-label" htmlFor="projectTypeId1">{prop.lang === 'en' ? 'Project Main':'โครงการวิจัย'}</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-check lg">
                                                            <input className="form-check-input" type="radio" value="" id="projectTypeId2" name="projectTypeId2" onChange={e => setProjectTypeId(Utils.PROJECT_TYPE_SET)} checked={Utils.PROJECT_TYPE_SET === projectTypeId} />
                                                            <label className="form-check-label" htmlFor="projectTypeId2">{prop.lang === 'en' ? 'Project Set':'ชุดโครงการวิจัย'}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <h4 className="title-line-left mt-5 mb-3">2. {prop.lang === 'en' ? 'Sub-research projects under the research project package (in case of selecting the project package type)':'โครงการวิจัยย่อยภายใต้ชุดโครงการวิจัย (กรณีเลือกประเภทโครงชุดโครงการ)'}</h4>
                                    <div className="row g-4">
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Project Sub Name':'ชื่อโครงการวิจัยย่อย'} <span className="star">*</span></h6>
                                                <input type="text" className="form-control" ref={refProjectsub} maxLength={250} disabled={Utils.PROJECT_TYPE_MAIN === projectTypeId} />
                                            </div>
                                        </div>
                                    </div>

                                    <h4 className="title-line-left mt-5 mb-3">3. {prop.lang === 'en' ? 'Research Project Type':'ลักษณะโครงการวิจัย'}</h4>
                                    <div className="row g-4">
                                        <div className="col-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-check lg">
                                                        <input className="form-check-input" type="radio" value="" id="researchTypeId1" name="researchTypeId1" onChange={e => setResearchTypeId(Utils.PROJECT_RESEARCH_TYPE_NEW)} checked={Utils.PROJECT_RESEARCH_TYPE_NEW === researchTypeId} />
                                                        <label className="form-check-label" htmlFor="researchTypeId1">{prop.lang === 'en' ? 'New Project':'โครงการใหม่'}</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-check lg">
                                                        <input className="form-check-input" type="radio" value="" id="researchTypeId2" name="researchTypeId2" onChange={e => setResearchTypeId(Utils.PROJECT_RESEARCH_TYPE_CONTINUE)} checked={Utils.PROJECT_RESEARCH_TYPE_CONTINUE === researchTypeId} />
                                                        <label className="form-check-label" htmlFor="researchTypeId2">{prop.lang === 'en' ? 'Ongoing Project':'โครงการต่อเนื่อง'}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-md-6">
                                            <div className="form-group">
                                                <div>
                                                    {
                                                        Utils.PROJECT_RESEARCH_TYPE_CONTINUE === researchTypeId ?
                                                        prop.lang === 'en' ? 'From the past fiscal year, operations':'จากปีงบประมาณที่ผ่านมา ดำเนินงาน' : prop.lang === 'en' ? 'That will start operations in the proposed year':'ที่เริ่มดำเนินการในปีที่เสนอขอ ดำเนินงาน'
                                                    } <span className="star">*</span>
                                                </div>
                                                <div className="input-group">
                                                    <input type="number" className="form-control text-center" ref={refBudgetYear} maxLength={11} min={1} />
                                                    <span className="input-group-text" id="basic-addon1">{prop.lang === 'en' ? 'Year':'ปี'}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-md-6">
                                            <div className="form-group">
                                                <div>{prop.lang === 'en' ? 'Total budget including projects':'งบประมาณรวมทั้งโครงการ'} <span className="star">*</span></div>
                                                <div className="input-group">
                                                    <input type="number" className="form-control text-center" ref={refBudgetPrice} maxLength={11} min={1} />
                                                    <span className="input-group-text" id="basic-addon1">{prop.lang === 'en' ? 'THB':'บาท'}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"col-xl-4 col-md-6" + (Utils.PROJECT_RESEARCH_TYPE_CONTINUE === researchTypeId ? '':' d-none')}>
                                            <div className="form-group">
                                                <div>{prop.lang === 'en' ? 'Start receiving the annual budget':'เริ่มรับงบประมาณปี'} <span className="star">*</span></div>
                                                <div className="input-group">
                                                    <input type="number" className="form-control text-center" ref={refBudgetStart} maxLength={4} min={1} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Summary':'สรุปผลการดำเนินงานที่ผ่านมา'} <span className="star">*</span></h6>
                                                <textarea className="form-control" ref={refSummary} maxLength={1000}></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <h4 className="title-line-left mt-5 mb-3">4. {prop.lang === 'en' ? 'Projects requesting funding from other agencies':'โครงการยื่นเสนอขอรับทุนจากหน่วยงานอื่น'}</h4>
                                    <div className="row g-4">
                                        <div className="col-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-check lg">
                                                        <input className="form-check-input" type="radio" value="" id="requestOther1" name="requestOther1" onChange={e => setRequestOther(Utils.REQUEST_OTHER_NO)} checked={Utils.REQUEST_OTHER_NO === requestOther} />
                                                        <label className="form-check-label" htmlFor="requestOther1">{prop.lang === 'en' ? 'No offer made':'ไม่มีการยื่นเสนอ'}</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-check lg">
                                                        <input className="form-check-input" type="radio" value="" id="requestOther2" name="requestOther2" onChange={e => setRequestOther(Utils.REQUEST_OTHER_YES)} checked={Utils.REQUEST_OTHER_YES === requestOther} />
                                                        <label className="form-check-label" htmlFor="requestOther2">{prop.lang === 'en' ? 'A proposal has been submitted':'มีการยื่นเสนอ'}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"col-12" + (Utils.REQUEST_OTHER_YES === requestOther ? '':' d-none')}>
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Agency/Institution':'ระบุหน่วยงาน/สถาบันที่ยื่น'} <span className="star">*</span></h6>
                                                <input type="text" className="form-control" ref={refPropOtherAgency} maxLength={250} />
                                            </div>
                                        </div>
                                        <div className={"col-12" + (Utils.REQUEST_OTHER_YES === requestOther ? '':' d-none')}>
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Project Name':' ชื่อโครงการ'} <span className="star">*</span></h6>
                                                <input type="text" className="form-control" ref={refPropOtherTitle} maxLength={250} />
                                            </div>
                                        </div>
                                        <div className={"col-12" + (Utils.REQUEST_OTHER_YES === requestOther ? '':' d-none')}>
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Differences from this project':' ระบุความแตกต่างจากโครงการนี้'} <span className="star">*</span></h6>
                                                <input type="text" className="form-control" ref={refPropOtherDiff} maxLength={250} />
                                            </div>
                                        </div>
                                    </div>

                                    <h4 className="title-line-left mt-5 mb-3">5. {prop.lang === 'en' ? 'Keywords (no more than 5 words) separated by ,':'คำสำคัญ (Keywords) (กำหนดไม่เกิน 5 คำ) คั่นด้วย ,'}</h4>
                                    <div className="row g-4">
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Thai':'ภาษาไทย'} <span className="star">*</span></h6>
                                                <input type="text" className="form-control" ref={refKeywords} maxLength={250} />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'English':'ภาษาอังกฤษ'} <span className="star">*</span></h6>
                                                <input type="text" className="form-control" ref={refKeywords_en} maxLength={250} />
                                            </div>
                                        </div>
                                    </div>

                                    <h4 className="title-line-left mt-5 mb-3">6. {prop.lang === 'en' ? 'ISCED':'ISCED'}</h4>
                                    <div className="row g-4">
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'ISCED Broad field ':'ISCED Broad field '} <span className="star">*</span></h6>
                                                <select className="form-select" onChange={onChangeIscedBroad}>
                                                    <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                    {
                                                        iscedBroadList !== null && iscedBroadList.count > 0 ?
                                                            iscedBroadList.rows.map((row, index) => {
                                                                return (
                                                                    <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                                )
                                                            }) : ''
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'ISCED Narrow field ':'ISCED Narrow field '} <span className="star">*</span></h6>
                                                <select className="form-select" onChange={onChangeIscedNarrow}>
                                                    <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                    {
                                                        iscedNarrowList !== null && iscedNarrowList.count > 0 ?
                                                            iscedNarrowList.rows.map((row, index) => {
                                                                return (
                                                                    <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                                )
                                                            }) : ''
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'ISCED Detailed field ':'ISCED Detailed field '} <span className="star">*</span></h6>
                                                <select className="form-select" onChange={onChangeIscedDetail}>
                                                    <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                    {
                                                        iscedDetailedList !== null && iscedDetailedList.count > 0 ?
                                                            iscedDetailedList.rows.map((row, index) => {
                                                            return (
                                                                <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                            )
                                                        }) : ''
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <h4 className="title-line-left mt-5 mb-3">7. {prop.lang === 'en' ? 'OECD':'สาขาการวิจัย (เลือกจากฐานข้อมูลในระบบ)'}</h4>
                                    <div className="row g-4">
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Main OECD':'สาขาการวิจัยหลัก OECD'} <span className="star">*</span></h6>
                                                <select className="form-select" onChange={onChangeOecdMain}>
                                                    <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                    {
                                                        oecdMainList !== null && oecdMainList.count > 0 ?
                                                            oecdMainList.rows.map((row, index) => {
                                                                return (
                                                                    <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                                )
                                                            }) : ''
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Sub OECD':'สาขาการวิจัยย่อย OECD'} <span className="star">*</span></h6>
                                                <select className="form-select" onChange={onChangeOecdSub}>
                                                    <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                    {
                                                        oecdSubList !== null && oecdSubList.count > 0 ?
                                                            oecdSubList.rows.map((row, index) => {
                                                                return (
                                                                    <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                                )
                                                            }) : ''
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Relation':'สาขาที่เกี่ยวข้อง'} <span className="star">*</span></h6>
                                                <select className="form-select" onChange={onChangeOecdRelation}>
                                                    <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                    {
                                                        oecdRelationList !== null && oecdRelationList.count > 0 ?
                                                            oecdRelationList.rows.map((row, index) => {
                                                                return (
                                                                    <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                                )
                                                            }) : ''
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="py-3"><hr /></div>
                                    <div className="buttons gap-15 py-0 mb-4">
                                        <button className="btn btn-gray w-130" type="button" onClick={onPrev}>{prop.lang === 'en' ? 'Prev':'ย้อนกลับ'}</button>
                                        <button className="btn btn-secondary w-130" type="button" onClick={onSubmit}>{prop.lang === 'en' ? 'Next':'บันทึกข้อมูล'}</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 